var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAulas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3713 0.602661C20.2073 0.602727 25.7688 6.16419 25.7688 13.0001C25.7687 19.836 20.2072 25.3975 13.3713 25.3976C6.5354 25.3976 0.973943 19.836 0.973877 13.0001C0.973877 6.16415 6.53536 0.602661 13.3713 0.602661ZM13.3713 1.85364C7.22494 1.85364 2.22485 6.85373 2.22485 13.0001C2.22492 19.1465 7.22498 24.1466 13.3713 24.1466C19.5176 24.1465 24.5178 19.1464 24.5178 13.0001C24.5178 6.85377 19.5177 1.8537 13.3713 1.85364Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.214457
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9567 8.31714C19.1885 8.24787 19.4391 8.32486 19.5875 8.50952C19.7358 8.69384 19.7528 8.94714 19.6305 9.14819L13.485 19.2605C13.3817 19.4303 13.197 19.5344 12.9987 19.5398L12.9127 19.5359L12.8795 19.531H12.8785C12.6376 19.4888 12.4511 19.3047 12.4078 19.073L11.5914 14.7039L11.5817 14.6482L11.5289 14.6257L7.37561 12.8171C7.15284 12.7199 7.01709 12.4991 7.03186 12.2644C7.04672 12.0296 7.2093 11.8266 7.44299 11.7566L18.9567 8.31714ZM17.5934 9.91284L9.5553 12.3142L9.27405 12.3982L9.5426 12.5154L12.3424 13.7341C12.5189 13.8111 12.644 13.9677 12.6783 14.1511L13.2281 17.0955L13.2789 17.3708L13.4254 17.1316L17.7155 10.071L17.86 9.83276L17.5934 9.91284Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.214457
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAulas);
export default __webpack_public_path__ + "static/media/Aulas.f334e766c41a77ff22a7827bcef76a5a.svg";
export { ForwardRef as ReactComponent };